import type {RoomID} from './types';
import {ClientCallType} from './clientCallType';

export const backoffBaseOptions = {min: 100, max: 30_000, jitter: 0.2};
export const NONE = 'none';
export const SDP_OFFER_IGNORED = 'offer_ignored';
export const APPLICATION_JSON = 'application/json';
export const MAX_RECONNECT_ATTEMPTS = 8;
export const DEFAULT_TOKEN_EXPIRES_SECS = 120;
export const TOKEN_VALIDITY_BUFFER_MS = 5_000;
export const GUID_MIN_LENGTH = 1;
export const MAIN_ROOM_ID: RoomID = 'main';
export const DEFAULT_BUFFER_SIZE = 50;
export const DEFAULT_CLIENT_CALLTYPE =
    ClientCallType.AudioSendRecvVideoSendRecvPresentationSendRecv;

/**
 * Default values for the video mixes
 * @see {@link https://docs.pexip.com/api_client/api_rest.htm?Highlight=video_mix#video_mixes}
 */
export const DEFAULT_MIX = 'main';
export const DEFAULT_PERSONAL_MIX = 'main.!personal';
